define('modules/Delivery//DeliveryZipCodeService',[
    'jquery',
    'global/all',
    'modules/User/Users',
], function ($, Roc) {
    'use strict';

    var cookieName = "Delivery.ZipCode";
    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var userZipCode = null;

    function getUserZipCode() {
        var deferred = $.Deferred();

        if (userZipCode) {
            Roc.Logger.info('DeliveryZipCodeService -> getUserZipCode() getting zip code from cache...');
            deferred.resolve(userZipCode);
            return deferred.promise();
        }

        userZipCode = Roc.Core.readCookie(cookieName);
        if (userZipCode !== null) {
            deferred.resolve(userZipCode);
            return deferred.promise();
        }

        $.ajax({
            url: apiUrl + '/api/user/delivery/zipcode',
            type: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            success: function (response) {
                if (response.status === 'Success') {
                    userZipCode = response.zipCode;
                    if (userZipCode !== null) {
                        Roc.Core.createCookie(cookieName, response.zipCode, 15);
                    }
                    deferred.resolve(userZipCode);
                    return;
                }

                userZipCode = null;
                deferred.reject(response.errorMessage);
            },
            error: function() {
                userZipCode = null;
                deferred.reject('An unexpected error has occured when getting delivery zip code.');
            }
        });

        return deferred.promise();
    }

    function setZipCode(zipCode) {
        var deferred = $.Deferred();
        $.ajax({
            url: apiUrl + '/api/user/delivery/zipcode/set',
            type: 'PUT',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({ zipCode: zipCode }),
            success: function (response) {
                if (response.status === 'Success') {
                    userZipCode = zipCode;
                    Roc.Core.createCookie(cookieName, zipCode, 15);
                    deferred.resolve(response);
                    return;
                }

                userZipCode = null;
                deferred.reject(response.errorMessage);
            },
            error: function () {
                userZipCode = null;
                deferred.reject('An unexpected error has occured when saving delivery zip code.');
            }
        });
        return deferred.promise();
    }

    function clearCookies() {
        Roc.Core.eraseCookie(cookieName);
    }


    var DeliveryZipCodeService = {
        getUserZipCode: getUserZipCode,
        setZipCode: setZipCode,
        clearCookies: clearCookies
    };

    Roc.Logger.debug('DeliveryZipCodeService.js Loaded:', DeliveryZipCodeService);

    return DeliveryZipCodeService;

});
